import React from 'react';
import './List.less';
import HwzComponent from '../../common/component/HwzComponent';
import PreviewerHelper from '../../pages/widget/previewer/PreviewerHelper';
import { withRouter } from 'react-router-dom';
import ForwardDialogModal from './widget/ForwardDialogModal';
import ExportAuditModal from './widget/ExportAuditModal';
import MatterPanel from './widget/MatterPanel';
import Pager from '../../common/model/base/Pager';
import Matter from '../../common/model/matter/Matter';
import Moon from '../../common/model/global/Moon';
import Director from './widget/Director';
import SortDirection from '../../common/model/base/SortDirection';
import DateUtil from '../../common/util/DateUtil';
import UploadMatterPanel from './widget/UploadMatterPanel';
import ThumbnailHelper from '../../pages/widget/previewer/ThumbnailHelper';
import {
  Button,
  Col,
  Switch,
  Empty,
  Input,
  Checkbox,
  Modal,
  Pagination,
  Progress,
  Row,
  Space as AntdSpace,
  Upload,
  Tooltip,
  Card,
  Dropdown,
  Menu,
  message,
} from 'antd';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import {
  FolderOpenOutlined,
  ExportOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DragOutlined,
  FolderOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
  ShareAltOutlined,
  SyncOutlined,
  SendOutlined,
  CloseCircleOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  MoreOutlined,
  AppstoreOutlined,
  BarsOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  EyeOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import Sun from '../../common/model/global/Sun';
import StringUtil from '../../common/util/StringUtil';
import MoveBatchModal from './widget/MoveBatchModal';
import MatterDeleteModal from './widget/MatterDeleteModal';
import Share from '../../common/model/share/Share';
import ShareDialogModal from '../share/widget/ShareDialogModal';
import BreadcrumbModel from '../../common/model/base/option/BreadcrumbModel';
import BreadcrumbPanel from '../widget/BreadcrumbPanel';
import Lang from '../../common/model/global/Lang';
import { UserRole } from '../../common/model/user/UserRole';
import SafeUtil from '../../common/util/SafeUtil';
import MatterSortPanel from './widget/MatterSortPanel';
import { UploadRequestOption as RcCustomRequestOptions } from 'rc-upload/lib/interface';
import Capacity from '../layout/widget/Capacity';
import Space from '../../common/model/space/Space';
import MatterCrawlModal from './widget/MatterCrawlModal';
import SpaceMember from '../../common/model/space/member/SpaceMember';
import { SpaceMemberRole } from '../../common/model/space/member/SpaceMemberRole';
import { RouteComponentProps } from 'react-router-dom';

interface IProps extends Partial<RouteComponentProps> {
  spaceUuid?: string;
}

interface IState {
  approvalView: boolean;
  crawlModalVisible: boolean;
  showExportAuditModal: boolean;
  selectedMatterForAudit: Matter | null;
  checkContent: boolean;
  searchLoading: boolean;
  forwardModalVisible: boolean;
  forwardProgressVisible: boolean;
  forwardProgressTaskId: string;
  forwardProgressTotal: number;
  forwardProgressCurrent: number;
  forwardProgressName: string;
  forwardProgressTotalBytes: number;
  forwardProgressFinishedBytes: number;
  forwardProgressDone: boolean;
  viewMode: 'list' | 'grid';
  thumbnailUrls: Record<string, string>;
  thumbnailLoading: Record<string, boolean>;
  editingMatterUuid: string | null;
  editingMatterName: string;
  isMobile: boolean;
}

type ApprovalStatusType = 'pending' | 'approved' | 'rejected' | 'draft' | 'normal' | 'outsend_pending' | 'outsend_approved' | 'outsend_rejected';

export default class List extends HwzComponent<IProps, IState> {
  isInSpace = !!this.props.spaceUuid;
  space = new Space();
  spaceMember = new SpaceMember();
  currentDirectory = new Matter();
  newMatter = new Matter();
  selectedMatters: Matter[] = [];
  searchText: string | null = null;
  pager = new Pager<Matter>(this, Matter, Pager.MAX_PAGE_SIZE);
  user = Moon.getSingleton().user;
  preference = Moon.getSingleton().preference;
  director = new Director();
  breadcrumbModels: BreadcrumbModel[] = [];
  share = new Share();
  newMatterRef = React.createRef<MatterPanel>();
  wrapperRef = React.createRef<HTMLDivElement>();
  uploadDirectoryBtnRef = React.createRef<HTMLElement>();
dragEnterCount = 0;
  forwardPollTimer: any = null;
  tempUploadList: File[] = [];
  uploadErrorLogs: [string, string, string][] = [];
  uploadMattersMap: Record<string, Matter[]> = Moon.getSingleton().uploadMattersMap;
  static instance: List | null = null;

  // 目录上传聚合进度（不使用 uploadMattersMap，避免创建 90k 个 React 组件）
  dirUploadTotal = 0;
  dirUploadDone = 0;
  dirUploadPhase: '' | 'scanning' | 'preparing' | 'creating_dirs' | 'uploading' | 'done' = '';
  dirUploadCurrentFile = '';
  dirUploadAborted = false;

  // 同步上传状态到全局 Sun（供 Frame 浮窗读取）
  private syncUploadStateToSun() {
    const sun = Sun.getSingleton();
    sun.dirUploadPhase = this.dirUploadPhase;
    sun.dirUploadDone = this.dirUploadDone;
    sun.dirUploadTotal = this.dirUploadTotal;
    sun.dirUploadCurrentFile = this.dirUploadCurrentFile;
  }

  // 读取取消信号：浮窗在 Sun 上设，上传逻辑在这读
  private isUploadAborted(): boolean {
    return this.dirUploadAborted || Sun.getSingleton().dirUploadAborted;
  }

  // 重写 updateUI，仅上传期间同步到 Sun（避免非上传时触发 Frame 重渲染）
  updateUI() {
    super.updateUI();
    if (this.dirUploadPhase) {
      this.syncUploadStateToSun();
    }
  }
  private mobileCheckTimer: any = null;
  private resizeListener: any = null;
  private isMenuClick = false;
  constructor(props: IProps) {
    super(props);

    List.instance = this;
    this.state = {
      approvalView: false,
      crawlModalVisible: false,
      showExportAuditModal: false,
      selectedMatterForAudit: null,
      checkContent: false,
      searchLoading: false,
      forwardModalVisible: false,
      forwardProgressVisible: false,
      forwardProgressTaskId: '',
      forwardProgressTotal: 0,
      forwardProgressCurrent: 0,
      forwardProgressName: '',
      forwardProgressTotalBytes: 0,
      forwardProgressFinishedBytes: 0,
      forwardProgressDone: false,
      viewMode: 'list',
      thumbnailUrls: {},
      thumbnailLoading: {},
      editingMatterUuid: null,
      editingMatterName: '',
      isMobile: false,
    };
  }

  drag = {
    dragEnterListener: (e: DragEvent) => {
      e.preventDefault();
      this.dragEnterCount++;
      if (this.dragEnterCount > 0) this.updateUI();
    },
    dragleaveListener: (e: DragEvent) => {
      e.preventDefault();
      this.dragEnterCount--;
      if (this.dragEnterCount <= 0) this.updateUI();
    },
    dragoverListener: (e: DragEvent) => {
      e.preventDefault();
    },
    dropListener: (e: DragEvent) => {
      e.preventDefault();
      this.dragEnterCount = 0;

      const items = e.dataTransfer?.items;
      if (!items || items.length === 0) return;

      // 先检查是否是目录拖拽（只检查顶层entry，不创建File对象）
      let topEntry: FileSystemEntry | null = null;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === 'file') {
          try {
            const entry = item.webkitGetAsEntry ? item.webkitGetAsEntry() : null;
            if (entry) {
              topEntry = entry;
              if (entry.isDirectory) break;
            }
          } catch (error) {
            console.log('webkitGetAsEntry not supported');
          }
        }
      }

      if (topEntry && topEntry.isDirectory) {
        // 目录拖拽：用 FileSystemDirectoryReader 懒加载枚举，避免一次性创建所有 File 对象
        this.scanAndUploadDirectory(topEntry as FileSystemDirectoryEntry);
      } else {
        // 普通文件拖拽：直接使用 dataTransfer.files
        const files = e.dataTransfer?.files;
        if (files && files.length > 0) {
          this.launchUpload(files);
        }
      }

      this.updateUI();
    },
    register: () => {
      console.log('Registering drag events...', this.wrapperRef.current);
      this.wrapperRef.current?.addEventListener(
        'dragenter',
        this.drag.dragEnterListener
      );
      this.wrapperRef.current?.addEventListener(
        'dragleave',
        this.drag.dragleaveListener
      );
      this.wrapperRef.current?.addEventListener(
        'dragover',
        this.drag.dragoverListener
      );
      this.wrapperRef.current?.addEventListener('drop', this.drag.dropListener);
    },
    unregister: () => {
      this.wrapperRef.current?.removeEventListener(
        'dragenter',
        this.drag.dragEnterListener
      );
      this.wrapperRef.current?.removeEventListener(
        'dragleave',
        this.drag.dragleaveListener
      );
      this.wrapperRef.current?.removeEventListener(
        'dragover',
        this.drag.dragoverListener
      );
      this.wrapperRef.current?.removeEventListener('drop', this.drag.dropListener);
    },
  };

  paste = {
    pasteListener: (e: ClipboardEvent) => {
      if (e.clipboardData?.files?.length! > 0) {
        this.launchUpload(e.clipboardData?.files!);
      }
    },
    register: () => {
      document.addEventListener('paste', this.paste.pasteListener);
    },
    unregister: () => {
      document.removeEventListener('paste', this.paste.pasteListener);
    },
  };

  handleMenuClick = (matter: Matter, key: string, e: any) => {
    if (e && e.domEvent) {
      e.domEvent.stopPropagation();
    }
    
    switch (key) {
      case 'download':
        matter.download();
        break;
      case 'rename':
        this.startRename(matter);
        break;
      case 'delete':
        const isSpace = false;
        MatterDeleteModal.open(
          isSpace,
          () => {
            matter.httpSoftDelete(() => {
              MessageBoxUtil.success(Lang.t('operationSuccess'));
              this.refreshAndClearSelection();
            }, (errorMsg: string) => {
              MessageBoxUtil.error(errorMsg);
            });
          },
          () => {
            matter.httpDelete(() => {
              MessageBoxUtil.success(Lang.t('operationSuccess'));
              this.refreshAndClearSelection();
            }, (errorMsg: string) => {
              MessageBoxUtil.error(errorMsg);
            });
          }
        );
        break;
      case 'move':
        MoveBatchModal.open(this.getSpaceUuid(), (targetUuid) => {
          Matter.httpMove(this.getSpaceUuid(), matter.uuid!, targetUuid, () => {
            MessageBoxUtil.success(Lang.t('operationSuccess'));
            this.refreshAndClearSelection();
          });
        });
        break;
      case 'preview':
        this.handlePreview(matter);
        break;
      case 'approve':
        this.handleApprove(matter);
        break;
      case 'reject':
        this.handleReject(matter);
        break;
    }
  };
  private handlePreview = async (matter: Matter) => {
    if (matter.dir) {
        this.goToDirectory(matter.uuid!);
        return;
    }

    try {
        const hasDownloadPermission = await this.checkFileDownloadPermission(matter);
        const hasPrintPermission = hasDownloadPermission;
        matter.preview(undefined, hasDownloadPermission, hasPrintPermission);
    } catch (error) {
        console.error('预览权限检查失败，仍尝试预览', error);
        matter.preview();
    }
};

handleMobileDirUpload = (e?: React.MouseEvent) => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }
  setTimeout(() => {
    if (this.hiddenDirInputRef.current) {
      this.hiddenDirInputRef.current.click();
    }
  }, 0);
};
  private hiddenDirInputRef = React.createRef<HTMLInputElement>();
  //private globalHiddenDirInput: HTMLInputElement | null = null; // 新增这一行
  private async checkFileDownloadPermission(matter: Matter): Promise<boolean> {
    if (!this.isInSpace) return true;
    const user = Moon.getSingleton().user;
    if (user.role === UserRole.ADMINISTRATOR) return true;
    if (matter.userUuid && matter.userUuid === user.uuid) return true;
    const role = this.spaceMember.role;
    if (role === null || role === undefined) return false;
    if (role === SpaceMemberRole.PREVIEW_ONLY || role === SpaceMemberRole.UPLOAD_PREVIEW) return false;
    return [SpaceMemberRole.READ_ONLY, SpaceMemberRole.READ_WRITE, SpaceMemberRole.ADMIN].includes(role);
  }

  startRename = (matter: Matter) => {
    this.setState({
      editingMatterUuid: matter.uuid!,
      editingMatterName: matter.name || '',
    });
  };

  saveRename = (matter: Matter) => {
    const { editingMatterName } = this.state;
    if (!editingMatterName.trim()) {
      MessageBoxUtil.warning(Lang.t('matter.nameCannotBeEmpty'));
      return;
    }
    if (editingMatterName === matter.name) {
      this.cancelRename();
      return;
    }
    matter.httpRename(editingMatterName, () => {
      MessageBoxUtil.success(Lang.t('operationSuccess'));
      this.cancelRename();
      this.refresh();
    }, (error: string) => {
      MessageBoxUtil.error(error || Lang.t('operationFailed'));
    });
  };

  cancelRename = () => {
    this.setState({
      editingMatterUuid: null,
      editingMatterName: '',
    });
  };

  handleApprovalViewChange = (checked: boolean) => {
    localStorage.setItem('matter_approval_view', checked.toString());
    this.setState({ approvalView: checked }, () => {
      if (!checked) this.pager.setFilterValue('deptId', undefined);
      this.refreshAndClearSelection();
    });
  }

  toggleViewMode = (mode: 'list' | 'grid') => {
    localStorage.setItem('matter_view_mode', mode);
    this.setState({ viewMode: mode });
  }

  async componentDidMount() {
    this.initSpace();
    this.pager.enableHistory();
    const savedViewMode = localStorage.getItem('matter_view_mode') as 'list' | 'grid' || 'list';
    const savedApprovalView = localStorage.getItem('matter_approval_view') === 'true';
    this.checkMobileDevice();
    this.setupMobileDetection();
    this.setState(
      {
        approvalView: savedApprovalView,
        viewMode: savedViewMode,
        isMobile: this.checkIsMobile(),
      },
      () => {
        this.refresh();
      }
    );
    this.refreshBreadcrumbs();
    this.drag.register();
    this.paste.register();
  }
  
  checkMobileDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    console.log('User Agent:', userAgent);
  }
  
  checkIsMobile(): boolean {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    return isMobileUserAgent || screenWidth <= 768;
  }
  
  setupMobileDetection() {
    const handleResize = () => {
      const isMobile = this.checkIsMobile();
      if (isMobile !== this.state.isMobile) {
        this.setState({ isMobile });
        console.log('屏幕宽度变化，更新移动端状态:', window.innerWidth, isMobile);
      }
    };
    this.resizeListener = handleResize;
    window.addEventListener('resize', handleResize);
    handleResize();
  }

  componentWillUnmount() {
    this.drag.unregister();
    this.paste.unregister();
    this.setState({
      thumbnailUrls: {},
      thumbnailLoading: {},
      editingMatterUuid: null,
      editingMatterName: '',
    });
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
    if (this.mobileCheckTimer) {
      clearTimeout(this.mobileCheckTimer);
    }
  }

  handleExportAudit = (values: any) => {
    const { selectedMatterForAudit } = this.state;
    if (!selectedMatterForAudit) {
      MessageBoxUtil.error(Lang.t('matter.selectFileFirst'));
      return;
    }
    selectedMatterForAudit.httpOutsendApply(
      values.reason,
      values.remark,
      () => {
        MessageBoxUtil.success(Lang.t('operationSuccess'));
        this.setState({ showExportAuditModal: false, selectedMatterForAudit: null });
        this.refreshAndClearSelection();
      },
      (error: string) => MessageBoxUtil.error(error)
    );
  };

  handleOpenExportAuditModal = () => {
    if (this.selectedMatters.length === 0) {
      MessageBoxUtil.warning(Lang.t('matter.selectFileFirst'));
      return;
    }
    this.setState({
      showExportAuditModal: true,
      selectedMatterForAudit: this.selectedMatters[0],
    });
  };

  forwardBatch() {
    if (this.selectedMatters.length === 0) {
      MessageBoxUtil.warning(Lang.t('matter.selectFileFirst'));
      return;
    }
    Modal.confirm({
      title: Lang.t('matter.forwardConfirmTitle'),
      content: Lang.t('matter.forwardConfirmContent').replace('{0}', this.selectedMatters.length.toString()),
      okText: Lang.t('confirm'),
      cancelText: Lang.t('cancel'),
      onOk: () => this.executeForwardToPersonalSpace()
    });
  }

  executeForwardToPersonalSpace() {
    const uuids = this.selectedMatters
      .map((i) => i.uuid)
      .filter(uuid => uuid && uuid !== '') as string[];
    console.log('转发的文件UUID:', uuids, '源空间UUID:', this.getSpaceUuid());
    if (uuids.length === 0) return;
    const taskId = this.generateForwardTaskId();
    this.startForwardProgressPolling(taskId);
    Matter.httpForwardBatchToPersonalSpace(
      uuids,
      this.getSpaceUuid(),
      taskId,
      (response: any) => {
        this.stopForwardProgressPolling();
        this.closeForwardProgress();
        MessageBoxUtil.success(Lang.t('matter.forwardSuccess'));
        console.log('转发成功:', response);
        this.refreshAndClearSelection();
        Capacity.instance?.refresh();
      },
      (error: string) => {
        this.stopForwardProgressPolling();
        this.closeForwardProgress();
        MessageBoxUtil.error(error || Lang.t('operationFailed'));
        console.error('转发失败:', error);
      }
    );
  }

  openForwardDialog = () => {
    if (this.selectedMatters.length === 0) {
      MessageBoxUtil.warning(Lang.t('matter.selectFileFirst'));
      return;
    }
    this.setState({ forwardModalVisible: true });
  };

  handleForward = (targetUserUuids: string[]) => {
    if (targetUserUuids.length === 0) {
      MessageBoxUtil.warning(Lang.t('matter.selectUserFirst'));
      return;
    }
    const uuids = this.selectedMatters
      .map((i) => i.uuid)
      .filter(uuid => uuid && uuid !== '') as string[];
    if (uuids.length === 0) {
      MessageBoxUtil.error(Lang.t('matter.selectFileFirst'));
      return;
    }
    Modal.confirm({
      title: Lang.t('matter.forwardConfirmTitle'),
      content: Lang.t('matter.forwardConfirmContent').replace('{0}', uuids.length.toString()),
      okText: Lang.t('confirm'),
      cancelText: Lang.t('cancel'),
      onOk: () => this.executeForwardToSpace(uuids, targetUserUuids)
    });
  };

  executeForwardToSpace = (uuids: string[], targetSpaceUuids: string[]) => {
    console.log('转发文件到空间:', uuids, '目标空间:', targetSpaceUuids, '源空间UUID:', this.getSpaceUuid());
    if (uuids.length === 0 || targetSpaceUuids.length === 0) return;
    const taskId = this.generateForwardTaskId();
    this.startForwardProgressPolling(taskId);
    Matter.httpForwardBatchToGroupSpaces(
      uuids,
      targetSpaceUuids,
      this.getSpaceUuid(),
      taskId,
      (response: any) => {
        this.stopForwardProgressPolling();
        this.closeForwardProgress();
        this.setState({ forwardModalVisible: false });
        let successCount = 0, failCount = 0;
        if (response.data?.data?.forwardResults) {
          const results = response.data.data.forwardResults;
          Object.values(results).forEach((result: any) => result.success ? successCount++ : failCount++);
        }
        if (failCount > 0) {
          MessageBoxUtil.info(
            Lang.t('matter.forwardPartialSuccess', successCount, failCount)
          );
        } else {
          MessageBoxUtil.success(Lang.t('matter.forwardSuccess'));
        }
        console.log('转发成功:', response);
        this.refreshAndClearSelection();
        Capacity.instance?.refresh();
      },
      (error: string) => {
        this.stopForwardProgressPolling();
        this.closeForwardProgress();
        this.setState({ forwardModalVisible: false });
        MessageBoxUtil.error(error || Lang.t('operationFailed'));
        console.error('转发失败:', error);
      }
    );
  };

  generateForwardTaskId() {
    return `fwd_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
  }

  startForwardProgressPolling(taskId: string) {
    this.setState({
      forwardProgressVisible: true,
      forwardProgressTaskId: taskId,
      forwardProgressTotal: 0,
      forwardProgressCurrent: 0,
      forwardProgressName: '',
      forwardProgressTotalBytes: 0,
      forwardProgressFinishedBytes: 0,
      forwardProgressDone: false,
    });
    this.stopForwardProgressPolling();
    this.forwardPollTimer = setInterval(() => {
      Matter.httpForwardProgress(
        taskId,
        (response: any) => {
          const p = response.data?.data;
          if (!p) return;
          const done = !!p.done;
          this.setState({
            forwardProgressTotal: p.totalItems ?? 0,
            forwardProgressCurrent: p.finishedItems ?? 0,
            forwardProgressName: typeof p.currentName === 'string' ? p.currentName : '',
            forwardProgressTotalBytes: p.totalBytes ?? 0,
            forwardProgressFinishedBytes: p.finishedBytes ?? 0,
            forwardProgressDone: done,
          });
          if (done) this.stopForwardProgressPolling();
        },
        () => {
          // 轮询失败忽略，转发请求本身的结果回调负责收尾
        }
      );
    }, 300);
  }

  stopForwardProgressPolling() {
    if (this.forwardPollTimer) {
      clearInterval(this.forwardPollTimer);
      this.forwardPollTimer = null;
    }
  }

  closeForwardProgress() {
    this.stopForwardProgressPolling();
    this.setState({
      forwardProgressVisible: false,
      forwardProgressTaskId: '',
    });
  }

  formatBytes(bytes: number): string {
    if (!bytes || bytes <= 0) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
  }

  renderForwardProgressModal() {
    const {
      forwardProgressVisible,
      forwardProgressTotal,
      forwardProgressCurrent,
      forwardProgressName,
      forwardProgressTotalBytes,
      forwardProgressFinishedBytes,
      forwardProgressDone,
    } = this.state;
    let percent = 0;
    if (forwardProgressTotalBytes > 0) {
      percent = Math.min(
        100,
        Math.ceil((forwardProgressFinishedBytes / forwardProgressTotalBytes) * 100)
      );
    } else if (forwardProgressTotal > 0) {
      percent = Math.min(
        100,
        Math.ceil((forwardProgressCurrent / forwardProgressTotal) * 100)
      );
    }
    if (!forwardProgressDone) {
      percent = Math.min(99, percent);
    }
    return (
      <Modal
        title={Lang.t('matter.forwardProgressTitle')}
        visible={forwardProgressVisible}
        footer={null}
        closable={false}
        maskClosable={false}
        width={480}
      >
        <Progress
          percent={percent}
          status={forwardProgressDone ? 'success' : 'active'}
        />
        {forwardProgressTotal > 0 && (
          <div style={{ marginTop: 12, color: '#666', fontSize: 14 }}>
            {Lang.t(
              'matter.forwardProgressContent',
              forwardProgressCurrent,
              forwardProgressTotal
            )}
          </div>
        )}
        {forwardProgressTotalBytes > 0 && (
          <div style={{ marginTop: 4, color: '#666', fontSize: 13 }}>
            {Lang.t(
              'matter.forwardProgressBytes',
              this.formatBytes(forwardProgressFinishedBytes),
              this.formatBytes(forwardProgressTotalBytes)
            )}
          </div>
        )}
        {forwardProgressName && (
          <div style={{ marginTop: 4, color: '#999', fontSize: 13 }}>
            {Lang.t('matter.forwardProgressCurrent', forwardProgressName)}
          </div>
        )}
      </Modal>
    );
  }

  checkMatter(matter?: Matter) {
    if (matter) {
      if (matter.check) {
        this.selectedMatters.push(matter);
      } else {
        const index = this.selectedMatters.findIndex(
          (item) => item.uuid === matter.uuid
        );
        this.selectedMatters.splice(index, 1);
      }
    } else {
      this.selectedMatters = [];
      this.pager.data.forEach((matter) => {
        if (matter.check) {
          this.selectedMatters.push(matter);
        }
      });
    }
    if (this.selectedMatters.length > 0) {
      this.setState({ selectedMatterForAudit: this.selectedMatters[0] });
    } else {
      this.setState({ selectedMatterForAudit: null });
    }
    this.updateUI();
  }

  handleDirectoryDragUpload(files: File[]) {
    const isDirectoryUpload = this.isDirectoryDrag(files);
    if (isDirectoryUpload) {
      this.tempUploadList = files;
      this.executeDirectoryUpload();
    } else {
      MessageBoxUtil.info(Lang.t('matter.dragAlternative'));
    }
  }

  isDirectoryDrag(files: File[]): boolean {
    if (files.length === 0) return false;
    const hasWebkitRelativePath = files.some(file => 
      file.webkitRelativePath && file.webkitRelativePath.includes('/')
    );
    const hasMultipleFiles = files.length > 1;
    const uniqueTypes = new Set(files.map(f => f.type));
    const hasMixedTypes = uniqueTypes.size > 1;
    const hasZeroByteFiles = files.some(f => f.size === 0);
    return hasWebkitRelativePath || (hasMultipleFiles && hasMixedTypes) || hasZeroByteFiles;
  }

  // 流式目录上传：扫描和上传并行，像成熟网盘一样发现一个传一个
  async scanAndUploadDirectory(dirEntry: FileSystemDirectoryEntry) {
    const rootUuid = this.currentDirectory.uuid!;
    const spaceUuid = this.getSpaceUuid();
    const yieldToMain = () => new Promise<void>(resolve => setTimeout(resolve, 0));

    // 目录路径 → UUID 映射
    const dirPathUuidMap: Record<string, string> = {};

    // MatterLock 是用户级锁，目录创建必须串行
    let dirQueue: Promise<any> = Promise.resolve();

    // 服务器创建目录（串行队列 + 重试）
    const createDirOnServer = async (name: string, parentUuid: string): Promise<string> => {
      return new Promise<string>((resolve) => {
        dirQueue = dirQueue.then(async () => {
          for (let attempt = 0; attempt < 3; attempt++) {
            const uuid = await new Promise<string>((res) => {
              const dirMatter = new Matter(this);
              dirMatter.name = name;
              dirMatter.puuid = parentUuid;
              dirMatter.spaceUuid = spaceUuid;
              dirMatter.httpCreateDirectory(
                () => res(dirMatter.uuid!),
                (msg: string) => {
                  if (msg && msg.includes('retry later') && attempt < 2) {
                    res('__RETRY__');
                  } else {
                    console.warn(`创建目录失败 ${name}:`, msg);
                    res('');
                  }
                }
              );
            });
            if (uuid === '__RETRY__') {
              await new Promise(r => setTimeout(r, 1500));
              continue;
            }
            resolve(uuid);
            return;
          }
          resolve('');
        });
      });
    };

    // 按路径确保目录存在，返回 UUID
    const ensureDirInFlight: Partial<Record<string, Promise<string>>> = {};
    const ensureDir = async (dirPath: string): Promise<string> => {
      if (!dirPath) return rootUuid;
      if (dirPathUuidMap[dirPath]) return dirPathUuidMap[dirPath];
      if (ensureDirInFlight[dirPath]) return ensureDirInFlight[dirPath]!;
      ensureDirInFlight[dirPath] = (async () => {
      const segments = dirPath.split('/');
      let parentUuid = rootUuid;
      let currentPath = '';
      for (const seg of segments) {
        currentPath = currentPath ? currentPath + '/' + seg : seg;
        if (dirPathUuidMap[currentPath]) {
          parentUuid = dirPathUuidMap[currentPath];
          continue;
        }
        const uuid = await createDirOnServer(seg, parentUuid);
        if (uuid) {
          dirPathUuidMap[currentPath] = uuid;
          parentUuid = uuid;
        }
      }
      delete ensureDirInFlight[dirPath];
      return dirPathUuidMap[dirPath] || rootUuid;
      })();
      return ensureDirInFlight[dirPath]!;
    };

    // ========= 生产者：扫描目录，发现文件立刻入队 =========
    interface PendingFile {
      entry: FileSystemFileEntry;
      relativePath: string;
      directoryPath: string;
    }
    const fileQueue: PendingFile[] = [];
    let scanDone = false;
    let scanError: any = null;
    let scannedCount = 0;
    let softWarningShown = false;

    const scanDirectory = async (entry: FileSystemDirectoryEntry, parentPath: string) => {
      const reader = entry.createReader();
      let batch: FileSystemEntry[];
      do {
        if (this.isUploadAborted()) return;
        batch = await new Promise<FileSystemEntry[]>((resolve) => reader.readEntries(resolve));
        for (const e of batch) {
          if (this.isUploadAborted()) return;
          const path = parentPath ? `${parentPath}/${e.name}` : e.name;
          if (e.isFile) {
            scannedCount++;
            fileQueue.push({
              entry: e as FileSystemFileEntry,
              relativePath: path,
              directoryPath: parentPath,
            });
            // 超过20万文件时显示软提示（不阻止）
            if (!softWarningShown && scannedCount > 200000) {
              softWarningShown = true;
              MessageBoxUtil.info(Lang.t('matter.tooManyFilesWarn', scannedCount));
            }
          } else if (e.isDirectory) {
            await scanDirectory(e as FileSystemDirectoryEntry, path);
          }
        }
        await yieldToMain();
      } while (batch.length > 0);
    };

    // ========= 消费者：上传工作者 =========
    let uploadIdx = 0;
    const CONCURRENCY = 3;

    const uploadWorker = async (): Promise<void> => {
      while (true) {
        // 等待队列中有文件可用
        while (uploadIdx >= fileQueue.length && !scanDone) {
          await yieldToMain();
        }
        if (uploadIdx >= fileQueue.length && scanDone) break;
        if (uploadIdx >= fileQueue.length) continue;

        const pending = fileQueue[uploadIdx++];
        try {
          // 按需创建目录
          const puuid = await ensureDir(pending.directoryPath);

          // 按需将 FileSystemFileEntry 转为 File 对象（不占常驻内存）
          const file = await new Promise<File>((resolve) => pending.entry.file(resolve));
          Object.defineProperty(file, 'webkitRelativePath', {
            value: pending.relativePath, writable: false,
          });

          this.dirUploadDone++;
          this.dirUploadCurrentFile = pending.relativePath;
          // 直接更新 Sun 浮窗状态（浮窗组件轮询读取）
          const sun = Sun.getSingleton();
          sun.dirUploadDone = this.dirUploadDone;
          sun.dirUploadTotal = this.dirUploadTotal;
          sun.dirUploadCurrentFile = this.dirUploadCurrentFile;
          if (this.dirUploadDone % 50 === 0) this.updateUI();

          await this.uploadFileToDirectorySilent(file, puuid);

          // 释放 File 引用，让 GC 回收
          (pending as any).entry = null;
        } catch (error) {
          this.uploadErrorLogs.push([pending.entry.name || '', pending.relativePath, String(error)]);
        }
      }
    };

    // ========= 启动：扫描 + 上传并行 =========
    this.dirUploadPhase = 'scanning';
    this.dirUploadDone = 0;
    this.dirUploadTotal = 0;
    this.dirUploadCurrentFile = '';
    this.dirUploadAborted = false;
    Sun.getSingleton().dirUploadAborted = false;
    this.updateUI();

    // 先为拖拽的根目录本身创建服务器端目录
    const rootDirUuid = await createDirOnServer(dirEntry.name, rootUuid);
    if (!rootDirUuid) {
      MessageBoxUtil.error(`创建目录 "${dirEntry.name}" 失败`);
      this.dirUploadPhase = '';
      this.updateUI();
      return;
    }
    dirPathUuidMap[dirEntry.name] = rootDirUuid;

    const scanningPromise = scanDirectory(dirEntry, dirEntry.name).catch((err) => { scanError = err; });

    // 等扫描出第一批文件后再启动上传工作者（避免空转）
    while (fileQueue.length === 0 && !scanDone && !scanError) {
      await yieldToMain();
    }

    if (scanError || fileQueue.length === 0 && !scanDone) {
      this.dirUploadPhase = '';
      this.updateUI();
      return;
    }

    this.dirUploadPhase = 'uploading';
    this.updateUI();

    const workers = Array.from({ length: CONCURRENCY }, () => uploadWorker());
    await scanningPromise;
    scanDone = true;
    await Promise.all(workers);

    this.dirUploadPhase = 'done';
    this.dirUploadTotal = this.dirUploadDone;
    this.updateUI();

    if (this.isUploadAborted()) {
      MessageBoxUtil.info(Lang.t('operationCancelled'));
    } else if (this.uploadErrorLogs.length === 0) {
      MessageBoxUtil.success(Lang.t('matter.uploaded'));
    } else {
      MessageBoxUtil.info(Lang.t('matter.uploadedWithErrors', this.uploadErrorLogs.length));
    }

    console.log(`流式上传完成：共上传 ${this.dirUploadDone} 个文件`);

    setTimeout(() => {
      this.dirUploadPhase = '';
      this.dirUploadTotal = 0;
      this.dirUploadDone = 0;
      this.uploadErrorLogs = [];
      this.updateUI();
      this.refresh();
    }, 2000);
  }

  // 按钮上传目录：安全上下文(HTTPS)用 showDirectoryPicker 懒扫描，HTTP 用动态 input
  async triggerButtonDirUpload() {
    if (window.isSecureContext && 'showDirectoryPicker' in window) {
      try {
        await this.uploadDirectoryViaPicker();
        return;
      } catch (err) {
        console.warn('showDirectoryPicker 失败，fallback 到 hidden input:', err);
      }
    }
    // HTTP 环境：动态创建 webkitdirectory input 触发目录选择
    const input = document.createElement('input');
    input.type = 'file';
    input.setAttribute('webkitdirectory', '');
    input.setAttribute('directory', '');
    input.multiple = true;
    input.style.display = 'none';
    input.addEventListener('change', () => {
      if (input.files && input.files.length) {
        const files = Array.from(input.files);
        if (files.length > 10000) {
          MessageBoxUtil.info(Lang.t('matter.tooManyFilesWarn', files.length));
        }
        this.tempUploadList = files;
        this.executeDirectoryUpload();
      }
      document.body.removeChild(input);
    });
    document.body.appendChild(input);
    input.click();
  }

  // Chromium: showDirectoryPicker 懒扫描上传（不卡浏览器）
  async uploadDirectoryViaPicker() {
    const dirHandle = await (window as any).showDirectoryPicker({ mode: 'readwrite' });

    const rootUuid = this.currentDirectory.uuid!;
    const spaceUuid = this.getSpaceUuid();
    const yieldToMain = () => new Promise<void>(resolve => setTimeout(resolve, 0));
    const dirPathUuidMap: Record<string, string> = {};

    // MatterLock 是用户级锁，目录创建必须串行
    let dirQueue: Promise<any> = Promise.resolve();

    const createDirOnServer = async (name: string, parentUuid: string): Promise<string> => {
      return new Promise<string>((resolve) => {
        dirQueue = dirQueue.then(async () => {
          for (let attempt = 0; attempt < 3; attempt++) {
            const uuid = await new Promise<string>((res) => {
              const dirMatter = new Matter(this);
              dirMatter.name = name;
              dirMatter.puuid = parentUuid;
              dirMatter.spaceUuid = spaceUuid;
              dirMatter.httpCreateDirectory(
                () => res(dirMatter.uuid!),
                (msg: string) => {
                  if (msg && msg.includes('retry later') && attempt < 2) {
                    res('__RETRY__');
                  } else {
                    console.warn(`创建目录失败 ${name}:`, msg);
                    res('');
                  }
                }
              );
            });
            if (uuid === '__RETRY__') {
              await new Promise(r => setTimeout(r, 1500));
              continue;
            }
            resolve(uuid);
            return;
          }
          resolve('');
        });
      });
    };

    const ensureDirInFlight: Partial<Record<string, Promise<string>>> = {};
    const ensureDir = async (dirPath: string): Promise<string> => {
      if (!dirPath) return rootUuid;
      if (dirPathUuidMap[dirPath]) return dirPathUuidMap[dirPath];
      if (ensureDirInFlight[dirPath]) return ensureDirInFlight[dirPath]!;
      ensureDirInFlight[dirPath] = (async () => {
        const segments = dirPath.split('/');
        let parentUuid = rootUuid;
        let currentPath = '';
        for (const seg of segments) {
          currentPath = currentPath ? currentPath + '/' + seg : seg;
          if (dirPathUuidMap[currentPath]) {
            parentUuid = dirPathUuidMap[currentPath];
            continue;
          }
          const uuid = await createDirOnServer(seg, parentUuid);
          if (uuid) {
            dirPathUuidMap[currentPath] = uuid;
            parentUuid = uuid;
          }
        }
        delete ensureDirInFlight[dirPath];
        return dirPathUuidMap[dirPath] || rootUuid;
      })();
      return ensureDirInFlight[dirPath]!;
    };

    interface PendingFile {
      file: File;
      relativePath: string;
      directoryPath: string;
    }
    const fileQueue: PendingFile[] = [];
    let scanDone = false;
    let scanError: any = null;
    let scannedCount = 0;
    let softWarningShown = false;

    // 懒扫描：用 FileSystemDirectoryHandle.values() 异步迭代器
    const scanHandle = async (handle: any, parentPath: string) => {
      try {
        for await (const [name, child] of handle.entries()) {
          if (this.isUploadAborted()) return;
          if (child.kind === 'file') {
            const file = await child.getFile();
            const path = parentPath ? `${parentPath}/${name}` : name;
            fileQueue.push({ file, relativePath: path, directoryPath: parentPath });
            scannedCount++;
            if (!softWarningShown && scannedCount > 200000) {
              softWarningShown = true;
              MessageBoxUtil.info(Lang.t('matter.tooManyFilesWarn', scannedCount));
            }
          } else if (child.kind === 'directory') {
            const path = parentPath ? `${parentPath}/${name}` : name;
            await scanHandle(child, path);
          }
          if (scannedCount % 1000 === 0) await yieldToMain();
        }
      } catch (err) {
        scanError = err;
      }
    };

    // ========= 启动 =========
    this.dirUploadPhase = 'scanning';
    this.dirUploadDone = 0;
    this.dirUploadTotal = 0;
    this.dirUploadCurrentFile = '';
    this.dirUploadAborted = false;
    Sun.getSingleton().dirUploadAborted = false;
    this.updateUI();

    // 先创建根目录
    const rootDirUuid = await createDirOnServer(dirHandle.name, rootUuid);
    if (!rootDirUuid) {
      MessageBoxUtil.error(`创建目录 "${dirHandle.name}" 失败`);
      this.dirUploadPhase = '';
      this.updateUI();
      return;
    }
    dirPathUuidMap[dirHandle.name] = rootDirUuid;

    const scanningPromise = scanHandle(dirHandle, dirHandle.name).catch((err) => { scanError = err; });

    // 等扫描出第一批文件后再启动上传工作者
    while (fileQueue.length === 0 && !scanDone && !scanError) {
      await yieldToMain();
    }

    if (scanError && fileQueue.length === 0) {
      this.dirUploadPhase = '';
      this.updateUI();
      return;
    }

    this.dirUploadPhase = 'uploading';
    this.updateUI();

    // 消费者：并发上传
    let uploadIdx = 0;
    const CONCURRENCY = 3;
    const uploadWorker = async (): Promise<void> => {
      while (true) {
        while (uploadIdx >= fileQueue.length && !scanDone) {
          await yieldToMain();
        }
        if (uploadIdx >= fileQueue.length && scanDone) break;
        if (uploadIdx >= fileQueue.length) continue;

        const pending = fileQueue[uploadIdx++];
        try {
          const puuid = await ensureDir(pending.directoryPath);
          this.dirUploadDone++;
          this.dirUploadCurrentFile = pending.relativePath;
          // 直接更新 Sun 浮窗状态（浮窗组件轮询读取）
          const sun = Sun.getSingleton();
          sun.dirUploadDone = this.dirUploadDone;
          sun.dirUploadTotal = this.dirUploadTotal;
          sun.dirUploadCurrentFile = this.dirUploadCurrentFile;
          if (this.dirUploadDone % 50 === 0) this.updateUI();
          await this.uploadFileToDirectorySilent(pending.file, puuid);
        } catch (error) {
          this.uploadErrorLogs.push([pending.file.name || '', pending.relativePath, String(error)]);
        }
      }
    };

    const workers = Array.from({ length: CONCURRENCY }, () => uploadWorker());
    await scanningPromise;
    scanDone = true;
    await Promise.all(workers);

    this.dirUploadPhase = 'done';
    this.dirUploadTotal = this.dirUploadDone;
    this.updateUI();

    if (this.isUploadAborted()) {
      MessageBoxUtil.info(Lang.t('operationCancelled'));
    } else if (this.uploadErrorLogs.length === 0) {
      MessageBoxUtil.success(Lang.t('matter.uploaded'));
    } else {
      MessageBoxUtil.info(Lang.t('matter.uploadedWithErrors', this.uploadErrorLogs.length));
    }

    setTimeout(() => {
      this.dirUploadPhase = '';
      this.dirUploadTotal = 0;
      this.dirUploadDone = 0;
      this.uploadErrorLogs = [];
      this.updateUI();
      this.refresh();
    }, 2000);
  }

  async executeDirectoryUpload() {
    if (this.tempUploadList.length === 0) return;
    this.dirUploadTotal = this.tempUploadList.length;
    this.dirUploadDone = 0;
    this.dirUploadPhase = 'preparing';
    this.dirUploadCurrentFile = '';
    this.dirUploadAborted = false;
    Sun.getSingleton().dirUploadAborted = false;
    this.updateUI();
    try {
      await this.uploadDirectory();
      this.dirUploadPhase = 'done';
      this.dirUploadDone = this.dirUploadTotal;
      this.updateUI();
      if (this.uploadErrorLogs.length === 0) {
        MessageBoxUtil.success(Lang.t('matter.uploaded'));
      } else {
        MessageBoxUtil.info(Lang.t('matter.uploadedWithErrors', this.uploadErrorLogs.length));
      }
    } catch (error) {
      console.error('Directory upload failed:', error);
      MessageBoxUtil.error(Lang.t('operationFailed'));
    } finally {
      this.tempUploadList = [];
      this.uploadErrorLogs = [];
        setTimeout(() => {
        this.dirUploadPhase = '';
        this.dirUploadTotal = 0;
        this.dirUploadDone = 0;
        this.updateUI();
        this.refreshAndClearSelection();
      }, 2000);
    }
  }

  componentWillReceiveProps(nextProps: IProps) {
    const spaceChanged = nextProps.spaceUuid !== this.props.spaceUuid;
    const urlChanged = nextProps.location?.search !== this.props.location?.search
                    || nextProps.location?.pathname !== this.props.location?.pathname;
    if (spaceChanged || urlChanged) {
      this.pager.enableHistory();
      this.refreshAndClearSelection();
      this.refreshBreadcrumbs();
    }
  }

  initSpace() {
    if (this.props.spaceUuid) {
      this.space.uuid = this.props.spaceUuid;
      this.space.httpDetail(() => this.updateUI());
      this.spaceMember.httpMine(this.props.spaceUuid, () => this.updateUI());
    }
  }

  refresh() {
    const selectedUuids = this.selectedMatters.map(m => m.uuid).filter(Boolean) as string[];
    this.setState({
      thumbnailUrls: {},
      thumbnailLoading: {},
      editingMatterUuid: null,
      editingMatterName: '',
    });
    this.refreshPager(() => {
      if (selectedUuids.length > 0) {
        this.restoreSelection(selectedUuids);
      }
    });
  }

  refreshAndClearSelection() {
    this.selectedMatters = [];
    this.setState({
      thumbnailUrls: {},
      thumbnailLoading: {},
      editingMatterUuid: null,
      editingMatterName: '',
    });
    this.refreshPager();
  }

  private restoreSelection(uuids: string[]) {
    const uuidSet = new Set(uuids);
    this.selectedMatters = [];
    this.pager.data.forEach(matter => {
      if (matter.uuid && uuidSet.has(matter.uuid)) {
        matter.check = true;
        this.selectedMatters.push(matter);
      }
    });
    if (this.selectedMatters.length > 0) {
      this.setState({ selectedMatterForAudit: this.selectedMatters[0] });
    }
    this.updateUI();
  }

  refreshPager(onDataLoaded?: () => void) {
    if (!this.pager.getFilterValue('puuid')) {
      this.pager.setFilterValue('puuid', Matter.MATTER_ROOT);
    }
    if (!this.pager.getCurrentSortFilter()) {
      this.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
      this.pager.setFilterValue('orderDir', SortDirection.DESC);
    }
    this.pager.setFilterValue('deleted', false);
    this.pager.setFilterValue('checkContent', this.state.checkContent);
    if (this.props.spaceUuid) {
      this.pager.setFilterValue('spaceUuid', this.props.spaceUuid);
    }
    if (this.state.approvalView) {
      this.pager.setFilterValue('approval', -1);
      this.pager.setFilterValue('outsendStatus', -1);
      const user = Moon.getSingleton().user;
      if (user.role === UserRole.ADMINISTRATOR && user.deptId) {
        this.pager.setFilterValue('deptId', user.deptId);
        console.log('审批模式下，管理员部门过滤:', user.deptId, '部门名称:', user.deptName);
      } else {
        this.pager.setFilterValue('deptId', undefined);
        if (user.role === UserRole.ADMINISTRATOR) {
          console.log('审批模式下，管理员无部门，显示所有待审批文件');
        }
      }
    } else {
      this.pager.setFilterValue('approval', 0);
      this.pager.setFilterValue('outsendStatus', 0);
      this.pager.setFilterValue('deptId', undefined);
    }
    if (this.searchText) {
      this.pager.setFilterValue('name', this.searchText);
    } else {
      this.pager.setFilterValue('name', undefined);
    }
    console.log('Pager 请求参数:', this.pager.getParams());
    console.log('当前模式:', this.state.approvalView ? '审批模式' : '正常模式');
    console.log('当前用户角色:', Moon.getSingleton().user.role);
    console.log('当前用户部门ID:', Moon.getSingleton().user.deptId);
    this.pager.httpList(() => {
      this.preloadThumbnailsForCurrentPage();
      if (onDataLoaded) onDataLoaded();
      console.log('文件列表加载完成，总数:', this.pager.totalItems);
    }, (error: any) => {
      console.error('文件列表加载失败:', error);
    });
  }

  preloadThumbnailsForCurrentPage() {
    const { pager } = this;
    const loadingUpdates: Record<string, boolean> = {};
    pager.data.forEach((matter) => {
      if (!matter.dir && ThumbnailHelper.isThumbnailSupported(matter.name)) {
        const uuid = matter.uuid!;
        loadingUpdates[uuid] = true;
        ThumbnailHelper.getThumbnailUrl(
          matter,
          { width: 200, height: 200, quality: 80, mode: 'cover' },
          (thumbnailUrl) => {
            this.setState(prevState => ({
              thumbnailUrls: {
                ...prevState.thumbnailUrls,
                [uuid]: thumbnailUrl,
              },
              thumbnailLoading: {
                ...prevState.thumbnailLoading,
                [uuid]: false,
              },
            }));
          },
          (error) => {
            console.warn(`缩略图加载失败: ${matter.name}`, error);
            this.setState(prevState => ({
              thumbnailLoading: {
                ...prevState.thumbnailLoading,
                [uuid]: false,
              },
            }));
          }
        );
      }
    });
    if (Object.keys(loadingUpdates).length > 0) {
      this.setState(prevState => ({
        thumbnailLoading: {
          ...prevState.thumbnailLoading,
          ...loadingUpdates,
        },
      }));
    }
  }

  checkAll() {
    this.pager.data.forEach((i) => {
      i.check = true;
    });
    this.checkMatter();
  }

  checkNone() {
    this.pager.data.forEach((i) => {
      i.check = false;
    });
    this.checkMatter();
  }

  deleteBatch() {
    const uuids = this.selectedMatters.map((i) => i.uuid).toString();
    MatterDeleteModal.open(
      !!this.props.spaceUuid,
      () => {
        Matter.httpSoftDeleteBatch(uuids, this.getSpaceUuid(), () => {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
          Capacity.instance?.refresh();
          this.refreshAndClearSelection();
        });
      },
      () => {
        Matter.httpDeleteBatch(uuids, this.getSpaceUuid(), () => {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
          Capacity.instance?.refresh();
          this.refreshAndClearSelection();
        });
      }
    );
  }

  downloadZip() {
    const uuids = this.selectedMatters.map((i) => i.uuid).toString();
    Matter.downloadZip(uuids, this.getSpaceUuid());
  }

  toggleMoveBatch() {
    MoveBatchModal.open(this.getSpaceUuid(), (targetUuid) => {
      const uuids = this.selectedMatters.map((i) => i.uuid).join(',');
      Matter.httpMove(this.getSpaceUuid(), uuids, targetUuid, () => {
        MessageBoxUtil.success(Lang.t('operationSuccess'));
        this.refreshAndClearSelection();
      });
    });
  }

  triggerUpload(fileObj: RcCustomRequestOptions) {
    const { file } = fileObj;
    if (file) this.launchUpload(file as any);
  }

  debounce(func: Function, wait: number) {
    let timer: any = null;
    return (fileObj: any) => {
      const { file } = fileObj;
      this.tempUploadList.push(file);
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(func, wait);
    };
  }

  triggerUploadDir = this.debounce(async (fileObj?: any) => {
    await this.executeDirectoryUpload();
  }, 300);

  async uploadDirectory(): Promise<void> {
    if (this.tempUploadList.length === 0) return;

    const dirPathUuidMap: Record<string, string> = {};
    const rootUuid = this.currentDirectory.uuid!;
    const spaceUuid = this.getSpaceUuid();
    const yieldToMain = () => new Promise<void>(resolve => setTimeout(resolve, 0));

    // 按需创建目录（不在预扫描，上传时按需创建）
    let dirQueue: Promise<any> = Promise.resolve();
    const createDirOnServer = async (name: string, parentUuid: string): Promise<string> => {
      return new Promise<string>((resolve) => {
        dirQueue = dirQueue.then(async () => {
          for (let attempt = 0; attempt < 3; attempt++) {
            const uuid = await new Promise<string>((res) => {
              const dirMatter = new Matter(this);
              dirMatter.name = name;
              dirMatter.puuid = parentUuid;
              dirMatter.spaceUuid = spaceUuid;
              dirMatter.httpCreateDirectory(
                () => res(dirMatter.uuid!),
                (msg: string) => {
                  if (msg && msg.includes('retry later') && attempt < 2) {
                    res('__RETRY__');
                  } else {
                    console.warn(`创建目录失败 ${name}:`, msg);
                    res('');
                  }
                }
              );
            });
            if (uuid === '__RETRY__') {
              await new Promise(r => setTimeout(r, 1500));
              continue;
            }
            resolve(uuid);
            return;
          }
          resolve('');
        });
      });
    };

    const ensureDirInFlight2: Partial<Record<string, Promise<string>>> = {};
    const ensureDir = async (dirPath: string): Promise<string> => {
      if (!dirPath) return rootUuid;
      if (dirPathUuidMap[dirPath]) return dirPathUuidMap[dirPath];
      if (ensureDirInFlight2[dirPath]) return ensureDirInFlight2[dirPath]!;
      ensureDirInFlight2[dirPath] = (async () => {
      const segments = dirPath.split('/');
      let parentUuid = rootUuid;
      let currentPath = '';
      for (const seg of segments) {
        currentPath = currentPath ? currentPath + '/' + seg : seg;
        if (dirPathUuidMap[currentPath]) {
          parentUuid = dirPathUuidMap[currentPath];
          continue;
        }
        const uuid = await createDirOnServer(seg, parentUuid);
        if (uuid) {
          dirPathUuidMap[currentPath] = uuid;
          parentUuid = uuid;
        }
      }
      delete ensureDirInFlight2[dirPath];
      return dirPathUuidMap[dirPath] || rootUuid;
      })();
      return ensureDirInFlight2[dirPath]!;
    };

    // 并发上传文件，目录按需创建
    this.dirUploadPhase = 'uploading';
    this.dirUploadTotal = this.tempUploadList.length;
    this.updateUI();
    const CONCURRENCY = 3;
    let idx = 0;
    const totalFiles = this.tempUploadList.length;
    const uploadNext = async (): Promise<void> => {
      while (idx < totalFiles && !this.isUploadAborted()) {
        const file = this.tempUploadList[idx++];
        this.dirUploadCurrentFile = file.webkitRelativePath || file.name;
        this.dirUploadDone = idx;
        // 直接更新 Sun 浮窗状态（浮窗组件轮询读取）
        const sun = Sun.getSingleton();
        sun.dirUploadDone = this.dirUploadDone;
        sun.dirUploadTotal = this.dirUploadTotal;
        sun.dirUploadCurrentFile = this.dirUploadCurrentFile;
        try {
          if (!file.webkitRelativePath) {
            await this.uploadFileToDirectorySilent(file, rootUuid);
          } else {
            const segments = file.webkitRelativePath.split('/');
            segments.pop();
            const directoryPath = segments.join('/');
            const targetPuuid = await ensureDir(directoryPath);
            await this.uploadFileToDirectorySilent(file, targetPuuid);
          }
        } catch (error) {
          this.uploadErrorLogs.push([file.name, file.webkitRelativePath || '', String(error)]);
        }
        if (idx % 200 === 0) {
          await yieldToMain();
          this.updateUI();
        }
      }
    };
    const workers = Array.from({ length: Math.min(CONCURRENCY, totalFiles) }, () => uploadNext());
    await Promise.all(workers);
  }
  
  async uploadFileToDirectorySilent(file: File, puuid: string): Promise<void> {
    return new Promise((resolve) => {
      const sizeLimit = this.getEffectiveSizeLimit();
      if (sizeLimit >= 0 && file.size > sizeLimit) {
        this.uploadErrorLogs.push([
          file.name,
          file.webkitRelativePath,
          Lang.t('matter.sizeExceedLimit', StringUtil.humanFileSize(file.size), StringUtil.humanFileSize(sizeLimit))
        ]);
        resolve();
        return;
      }
      const matter = new Matter(this);
      matter.dir = false;
      matter.puuid = puuid;
      matter.spaceUuid = this.getSpaceUuid();
      matter.file = file;
      matter.httpUpload(
        () => resolve(),
        (msg: string) => {
          this.uploadErrorLogs.push([file.name, file.webkitRelativePath, msg]);
          resolve();
        }
      );
    });
  }

  launchUpload(
    f: File | FileList,
    puuid = this.currentDirectory.uuid!,
    errHandle = () => {}
  ) {
    if (!(f instanceof FileList)) {
      const file = f as File;
      const sizeLimit = this.getEffectiveSizeLimit();
      if (sizeLimit >= 0 && file.size > sizeLimit) {
        MessageBoxUtil.error(
          Lang.t('matter.sizeExceedLimit', StringUtil.humanFileSize(file.size), StringUtil.humanFileSize(sizeLimit))
        );
        return;
      }
      const m = new Matter(this);
      m.dir = false;
      m.puuid = puuid;
      m.spaceUuid = this.getSpaceUuid();
      m.file = file;
      if (!this.uploadMattersMap[this.getSpaceUuid()]) {
        this.uploadMattersMap[this.getSpaceUuid()] = [];
      }
      this.uploadMattersMap[this.getSpaceUuid()].push(m);
      m.httpUpload(
        () => {
          const index = this.uploadMattersMap[this.getSpaceUuid()].findIndex((matter) => matter === m);
          if (index !== -1) this.uploadMattersMap[this.getSpaceUuid()].splice(index, 1);
          List.instance?.refresh();
          Capacity.instance?.refresh();
        },
        (msg: string) => { List.instance?.updateUI(); SafeUtil.safeCallback(errHandle)(msg); }
      );
      return;
    }

    const fileList = f;
    const CHUNK_SIZE = 2000;
    let i = 0;
    const dirFiles: File[] = [];
    const regFiles: File[] = [];

    const categorizeChunk = () => {
      const end = Math.min(i + CHUNK_SIZE, fileList.length);
      for (; i < end; i++) {
        const file = fileList[i];
        if (file.webkitRelativePath && file.webkitRelativePath.includes('/')) {
          dirFiles.push(file);
        } else {
          regFiles.push(file);
        }
      }
      if (i < fileList.length) {
        setTimeout(categorizeChunk, 0);
      } else {
        if (dirFiles.length > 0) {
          this.tempUploadList = [...this.tempUploadList, ...dirFiles];
          this.debouncedUploadDirectory();
        } else {
          for (let j = 0; j < regFiles.length; j++) {
            const file = regFiles[j];
            const sizeLimit = this.getEffectiveSizeLimit();
            if (sizeLimit >= 0 && file.size > sizeLimit) {
              MessageBoxUtil.error(
                Lang.t('matter.sizeExceedLimit', StringUtil.humanFileSize(file.size), StringUtil.humanFileSize(sizeLimit))
              );
              continue;
            }
            const m = new Matter(this);
            m.dir = false;
            m.puuid = puuid;
            m.spaceUuid = this.getSpaceUuid();
            m.file = file;
            m.httpUpload(
              () => {
                const index = this.uploadMattersMap[this.getSpaceUuid()].findIndex((matter) => matter === m);
                if (index !== -1) this.uploadMattersMap[this.getSpaceUuid()].splice(index, 1);
                List.instance?.refresh();
                Capacity.instance?.refresh();
              },
              (msg: string) => { List.instance?.updateUI(); SafeUtil.safeCallback(errHandle)(msg); }
            );
            if (!this.uploadMattersMap[this.getSpaceUuid()]) {
              this.uploadMattersMap[this.getSpaceUuid()] = [];
            }
            this.uploadMattersMap[this.getSpaceUuid()].push(m);
          }
        }
      }
    };

    categorizeChunk();
  }

  debouncedUploadDirectory = () => {
    this.executeDirectoryUpload();
  }

  shareBatch() {
    const uuids = this.selectedMatters
      .map((i) => i.uuid)
      .filter(uuid => uuid && uuid !== '')
      .join(',');
    console.log('分享的文件UUID:', uuids);
    if (!uuids) {
      MessageBoxUtil.error(Lang.t('matter.selectFileFirst'));
      return;
    }
    ShareDialogModal.open(uuids);
  }

  searchFile(value?: string, checkContent: boolean = this.state.checkContent) {
    console.log('search', value, 'checkContent:', checkContent);
    if (this.state.searchLoading) return;
    this.setState({ searchLoading: true });
    if (this.state.approvalView) {
      const user = Moon.getSingleton().user;
      if (user.role === UserRole.ADMINISTRATOR && user.deptId) {
        this.pager.setFilterValue('deptId', user.deptId);
      } else {
        this.pager.setFilterValue('deptId', undefined);
      }
    } else {
      this.pager.setFilterValue('deptId', undefined);
    }
    if (value) {
      if (checkContent) {
        this.pager.setFilterValue('name', value);
        this.pager.setFilterValue('checkContent', checkContent);
      } else {
        this.pager.setFilterValue('name', value);
        this.pager.setFilterValue('checkContent', undefined);
      }
    } else {
      this.pager.setFilterValue('name', undefined);
      this.pager.setFilterValue('checkContent', undefined);
    }
    this.pager.setFilterValue('page', 0);
    this.pager.httpList(() => {
      this.setState({ searchLoading: false });
    }, () => {
      this.setState({ searchLoading: false });
    });
  }

  handleFullTextSearchChange = (e: any) => {
    const checked = e.target.checked;
    this.setState({ checkContent: checked });
    const searchInput = document.querySelector('.ant-input-search input') as HTMLInputElement;
    if (searchInput && searchInput.value) {
      MessageBoxUtil.info(Lang.t('matter.fullTextSearchChangeHint'));
    }
  }

  changeSearch(e: any) {
    console.log('change', e.currentTarget.value);
    if (!e.currentTarget.value && !this.state.searchLoading) {
      this.searchFile();
    }
  }

  changePage(page: number) {
    this.pager.page = page - 1;
    this.pager.httpList();
    this.updateUI();
  }

  getSpaceUuid() {
    if (this.props.spaceUuid) return this.props.spaceUuid;
    return this.user.spaceUuid!;
  }

  getEffectiveSizeLimit() {
    const targetSpaceUuid = this.getSpaceUuid();
    if (targetSpaceUuid === this.user.spaceUuid) {
      return this.user.space ? this.user.space.sizeLimit : -1;
    }
    return this.space.sizeLimit === 0 ? -1 : this.space.sizeLimit;
  }

  createDirectory() {
    this.newMatter.name = 'matter.allFiles';
    this.newMatter.dir = true;
    this.newMatter.editMode = true;
    this.newMatter.puuid = this.currentDirectory.uuid || Matter.MATTER_ROOT;
    this.newMatter.spaceUuid = this.getSpaceUuid();
    this.director.createMode = true;
    this.updateUI();
    setTimeout(() => this.newMatterRef.current!.highLight());
  }

  goDetail(matter: Matter) {
    const prefix = this.isInSpace ? `/space/${this.getSpaceUuid()}` : '';
    Sun.navigateTo(`${prefix}/matter/detail/${matter.uuid}`);
  }

  pagerAndCapacityRefresh() {
    Capacity.instance?.refresh();
    this.refresh();
  }

  checkDownloadPermission() {
    if (!this.isInSpace) return true;
    if (this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY || 
        this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW) {
      return false;
    }
    return [SpaceMemberRole.READ_ONLY, SpaceMemberRole.READ_WRITE, SpaceMemberRole.ADMIN].includes(
      this.spaceMember.role!
    );
  }

  checkMovePermission() {
    if (!this.isInSpace) return true;
    if (this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY || 
        this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW) {
      return false;
    }
    return [SpaceMemberRole.READ_WRITE, SpaceMemberRole.ADMIN].includes(
      this.spaceMember.role!
    );
  }

  checkCreatePermission() {
    if (!this.isInSpace) return true;
    if (this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY || 
        this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW) {
      return false;
    }
    return [SpaceMemberRole.READ_WRITE, SpaceMemberRole.ADMIN].includes(
      this.spaceMember.role!
    );
  }

  checkHandlePermission() {
    if (!this.isInSpace) return true;
    if (this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY) return false;
    if (this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW) return false;
    return [SpaceMemberRole.ADMIN, SpaceMemberRole.READ_WRITE].includes(
      this.spaceMember.role!
    );
  }

  checkPreviewOnlyPermission() {
    if (!this.isInSpace) return false;
    return this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY;
  }

  checkUploadPreviewPermission() {
    if (!this.isInSpace) return false;
    return this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW;
  }

  handleCloseMatterCrawlModal() {
    this.setState({ crawlModalVisible: false });
    this.pagerAndCapacityRefresh();
  }

  goToDirectory(id: string) {
    console.log('goToDirectory 被调用，id =', id);
    
    // 调试弹窗（稳定后可删除）
    //alert('尝试跳转到目录：' + id);

    this.searchText = null;
    this.pager.setFilterValues({
        puuid: id,
        name: undefined,
    });
    this.pager.page = 0;

    const query = this.pager.getParams();
    const targetPath = this.getMatterListPath();

    // 方法1：使用 React Router 的 history（无刷新跳转，所有平台通用）
    if (this.props.history) {
        const searchParams = new URLSearchParams();
        Object.keys(query).forEach(key => {
            const value = query[key];
            if (value !== undefined && value !== null && value !== '') {
                searchParams.append(key, String(value));
            }
        });
        const fullPath = searchParams.toString() 
            ? `${targetPath}?${searchParams.toString()}` 
            : targetPath;
        console.log('history.push ->', fullPath);
        this.props.history.push(fullPath);
        return;
    }

    // 方法2：降级使用原来的 Sun.navigateQueryTo
    if (typeof Sun.navigateQueryTo === 'function') {
        console.log('降级使用 Sun.navigateQueryTo');
        Sun.navigateQueryTo({ path: targetPath, query });
        this.refreshAndClearSelection();
        return;
    }

    // 方法3：最终降级，强制刷新页面（保证功能可用）
    const url = new URL(window.location.href);
    url.pathname = targetPath;
    Object.keys(query).forEach(key => {
        const value = query[key];
        if (value !== undefined && value !== null && value !== '') {
            url.searchParams.set(key, String(value));
        }
    });
    console.log('最终降级：window.location.href =', url.toString());
    window.location.href = url.toString();
}
  getMatterListPath() {
    if (this.props.spaceUuid)
      return `/space/${this.props.spaceUuid}/matter/list`;
    return '/matter/list';
  }

  refreshBreadcrumbs() {
    this.currentDirectory.uuid =
      this.pager.getFilterValue('puuid') || Matter.MATTER_ROOT;
    const isRootDirectory = this.currentDirectory.uuid === Matter.MATTER_ROOT;
    const rootBreadcrumb = {
      name: Lang.t('matter.allFiles'),
      path: this.getMatterListPath(),
      query: {},
      displayDirect: isRootDirectory,
    };
    this.breadcrumbModels = [rootBreadcrumb];
    if (!isRootDirectory) {
      this.currentDirectory.spaceUuid = this.getSpaceUuid();
      this.currentDirectory.httpDetail(() => {
        const arr = [];
        let cur: Matter | null = this.currentDirectory;
        do {
          arr.push(cur);
          cur = cur.parent;
        } while (cur);
        this.breadcrumbModels = arr.reduceRight(
          (t: any, item: Matter, i: number) => {
            const query = this.pager.getParams();
            query['puuid'] = item.uuid!;
            t.push({
              name: item.name,
              path: this.getMatterListPath(),
              query: query,
              displayDirect: !i,
            });
            return t;
          },
          [rootBreadcrumb]
        );
        this.updateUI();
      });
    }
  }

  getBreadcrumbModels(): BreadcrumbModel[] {
    if (this.props.spaceUuid) {
      if (!this.space.name) return [];
      return [
        {
          name: this.space.name,
          path: '/space',
          query: {},
          displayDirect: false,
        },
      ].concat(this.breadcrumbModels);
    }
    return this.breadcrumbModels;
  }

  getFileIcon = (matter: Matter) => {
    if (matter.dir) {
      return <FolderOutlined style={{ fontSize: '48px', color: '#ffa940' }} />;
    }
    const icon = ThumbnailHelper.getFileIcon(matter.name);
    const style = {
      fontSize: '48px',
      color: this.getFileIconColor(matter.name),
    };
    return (
      <div style={style} title={icon}>
        {icon}
      </div>
    );
  };

  getFileIconColor = (fileName: string): string => {
    const extension = ThumbnailHelper.getFileExtension(fileName);
    if (ThumbnailHelper.isImageExtension(extension)) return '#52c41a';
    if (ThumbnailHelper.isDocumentExtension(extension)) return '#1890ff';
    if (ThumbnailHelper.isVideoExtension(extension)) return '#faad14';
    if (ThumbnailHelper.isAudioExtension(extension)) return '#722ed1';
    return '#bfbfbf';
  };

  getApprovalStatus(matter: Matter): ApprovalStatusType {
    if (matter.approval === -1) return 'pending';
    if (matter.approval === 1) return 'approved';
    if (matter.approval === 2) return 'rejected';
    if (matter.outsendStatus === -1) return 'outsend_pending';
    if (matter.outsendStatus === 1) return 'outsend_approved';
    if (matter.outsendStatus === 2) return 'outsend_rejected';
    return 'normal';
  }

  getApprovalStatusText(status: ApprovalStatusType): string {
    const textMap: Record<ApprovalStatusType, string> = {
      pending: Lang.t('matter.pending'),
      approved: Lang.t('matter.approved'),
      rejected: Lang.t('matter.rejected'),
      draft: Lang.t('matter.draft'),
      normal: Lang.t('matter.normal'),
      outsend_pending: Lang.t('matter.outsendPending'),
      outsend_approved: Lang.t('matter.outsendApproved'),
      outsend_rejected: Lang.t('matter.outsendRejected'),
    };
    return textMap[status] || Lang.t('matter.unknownStatus');
  }

  getApprovalStatusColor(status: ApprovalStatusType): string {
    const colorMap: Record<ApprovalStatusType, string> = {
      pending: '#fa8c16',
      approved: '#52c41a',
      rejected: '#f5222d',
      draft: '#8c8c8c',
      normal: '#1890ff',
      outsend_pending: '#fa8c16',
      outsend_approved: '#52c41a',
      outsend_rejected: '#f5222d',
    };
    return colorMap[status] || '#1890ff';
  }

  handleApprove = (record: Matter) => {
    Modal.confirm({
      title: Lang.t('matter.confirmApproval'),
      icon: <ExclamationCircleOutlined />,
      content: Lang.t('matter.confirmApproveFile').replace('{fileName}', record.name),
      onOk: () => {
        try {
          const originalApproval = record.approval;
          record.approval = 1;
          record.httpApproval(
            () => {
              MessageBoxUtil.success(Lang.t('matter.approveSuccess').replace('{fileName}', record.name));
              this.refreshAndClearSelection();
            },
            (error: string) => {
              record.approval = originalApproval;
              MessageBoxUtil.error(error);
              this.refreshAndClearSelection();
            }
          );
        } catch (error) {
          message.error(Lang.t('operationFailed'));
        }
      },
    });
  };

  handleReject = (record: Matter) => {
    Modal.confirm({
      title: Lang.t('matter.confirmReject'),
      icon: <ExclamationCircleOutlined />,
      content: Lang.t('matter.confirmRejectFile').replace('{fileName}', record.name),
      onOk: () => {
        try {
          const originalApproval = record.approval;
          record.approval = 2;
          record.httpApproval(
            () => {
              MessageBoxUtil.warning(Lang.t('matter.rejectSuccess').replace('{fileName}', record.name));
              this.refreshAndClearSelection();
            },
            (error: string) => {
              record.approval = originalApproval;
              MessageBoxUtil.error(error);
              this.refreshAndClearSelection();
            }
          );
        } catch (error) {
          message.error(Lang.t('operationFailed'));
        }
      },
    });
  };

  handleMobileStatusClick = (record: Matter, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const status = this.getApprovalStatus(record);
    if (status !== 'pending' && status !== 'outsend_pending') return;
    Modal.confirm({
      title: Lang.t('matter.approvalOperation'),
      content: Lang.t('matter.chooseOperationForFile').replace('{fileName}', record.name),
      okText: Lang.t('matter.pass'),
      cancelText: Lang.t('matter.reject'),
      onOk: () => this.handleApprove(record),
      onCancel: () => this.handleReject(record),
    });
  };

  // ==================== 移动端专用方法 ====================
  /**
   * 获取移动端头部更多菜单内容
   */
  getMobileMenu = () => {
    const { hasFullPermission, canCreate, canDownload, canMove, canShowShareButton } = this.getMobilePermissions();
    const hasSelected = this.selectedMatters.length > 0;
    const isAllSelected = this.pager.data.length > 0 && this.selectedMatters.length === this.pager.data.length;
  
    return (
      <Menu>
        {canCreate && (
          <Menu.Item key="createDir" icon={<FolderOutlined />} onClick={() => this.createDirectory()}>
            {Lang.t('matter.create')}
          </Menu.Item>
        )}
        {this.pager.data.length > 0 && (
          <Menu.Item 
            key="selectAll" 
            icon={isAllSelected ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
            onClick={() => isAllSelected ? this.checkNone() : this.checkAll()}
          >
            {isAllSelected ? Lang.t('cancel') : Lang.t('selectAll')}
          </Menu.Item>
        )}
        {hasSelected && (
          <>
            <Menu.Divider />
            {canDownload && (
              <Menu.Item key="batchDownload" icon={<DownloadOutlined />} onClick={() => this.downloadZip()}>
                {Lang.t('download')}
              </Menu.Item>
            )}
            {hasFullPermission && (
              <Menu.Item key="batchDelete" icon={<DeleteOutlined />} danger onClick={() => this.deleteBatch()}>
                {Lang.t('delete')}
              </Menu.Item>
            )}
            {canMove && (
              <Menu.Item key="batchMove" icon={<DragOutlined />} onClick={() => this.toggleMoveBatch()}>
                {Lang.t('matter.move')}
              </Menu.Item>
            )}
            {this.isInSpace && (hasFullPermission || canDownload || canMove) && (
              <Menu.Item key="batchForward" icon={<SendOutlined />} onClick={() => this.forwardBatch()}>
                {Lang.t('matter.forward')}
              </Menu.Item>
            )}
            {!this.isInSpace && hasFullPermission && (
              <Menu.Item key="batchForwardSpace" icon={<SendOutlined />} onClick={() => this.openForwardDialog()}>
                {Lang.t('matter.forwardToSpace')}
              </Menu.Item>
            )}
            {canShowShareButton && hasFullPermission && (
              <Menu.Item key="batchShare" icon={<ShareAltOutlined />} onClick={() => this.shareBatch()}>
                {Lang.t('matter.share')}
              </Menu.Item>
            )}
          </>
        )}
      </Menu>
    );
  };

  /**
   * 获取移动端权限集合
   */
  getMobilePermissions = () => {
    const isUploadPreview = this.checkUploadPreviewPermission();
    const hasFullPermission = this.checkHandlePermission();
    const canCreate = this.checkCreatePermission();
    const canDownload = this.checkDownloadPermission();
    const canMove = this.checkMovePermission();
    const canShowShareButton = !this.isInSpace && !this.user.disableShare;
    return { isUploadPreview, hasFullPermission, canCreate, canDownload, canMove, canShowShareButton };
  };

  /**
   * 渲染移动端头部操作栏（紧凑靠左布局）
   */
  renderMobileHeader = () => {
    const { approvalView, checkContent, searchLoading } = this.state;
    const user = Moon.getSingleton().user;
    const canUpload = this.checkUploadPreviewPermission() || this.checkHandlePermission();
    const canShowExportAudit = !this.isInSpace && user.role !== UserRole.ADMINISTRATOR;
  
    return (
      <div className="mobile-header-container">
        {/* 隐藏的目录上传 input - 使用类型断言解决 webkitdirectory 类型错误 */}
        <input
          ref={this.hiddenDirInputRef}
          type="file"
          {...({ webkitdirectory: "", directory: "" } as any)}
          style={{ display: 'none' }}
          multiple
          onChange={(e) => {
            if (e.target.files && e.target.files.length) {
              const files = Array.from(e.target.files);
              if (files.length > 10000) {
                MessageBoxUtil.info(Lang.t('matter.tooManyFilesWarn', files.length));
              }
              this.tempUploadList = files;
              this.executeDirectoryUpload();
              e.target.value = '';
            }
          }}
        />
  
        <div className="mobile-action-bar">
          <AntdSpace size="small" wrap={false} className="action-left">
            <Button.Group className="view-toggle-buttons">
              <Tooltip title={Lang.t('matter.listView')}>
                <Button
                  type={this.state.viewMode === 'list' ? 'primary' : 'default'}
                  icon={<BarsOutlined />}
                  onClick={() => this.toggleViewMode('list')}
                  size="small"
                />
              </Tooltip>
              <Tooltip title={Lang.t('matter.gridView')}>
                <Button
                  type={this.state.viewMode === 'grid' ? 'primary' : 'default'}
                  icon={<AppstoreOutlined />}
                  onClick={() => this.toggleViewMode('grid')}
                  size="small"
                />
              </Tooltip>
            </Button.Group>
  
            {canUpload && (
              <Upload
                className="ant-upload"
                customRequest={(e) => this.triggerUpload(e)}
                showUploadList={false}
                multiple
              >
                <Button size="small" icon={<CloudUploadOutlined />}>
                  {Lang.t('matter.upload')}
                </Button>
              </Upload>
            )}
  
            <Button size="small" icon={<SyncOutlined />} onClick={() => this.refresh()}>
              {Lang.t('refresh')}
            </Button>
  
            <Dropdown overlay={this.getMobileMenu()} trigger={['click']} placement="bottomLeft">
              <Button size="small" icon={<MoreOutlined />}>
                {Lang.t('more')}
              </Button>
            </Dropdown>
          </AntdSpace>
        </div>
  
        <div className="mobile-search-area">
          {user.role === UserRole.ADMINISTRATOR ? (
            <div className="approval-switch-mobile">
              <Switch
                checked={approvalView}
                onChange={this.handleApprovalViewChange}
                size="small"
                checkedChildren={Lang.t('matter.approvalMode')}
                unCheckedChildren={Lang.t('matter.normalMode')}
                style={{ backgroundColor: approvalView ? '#fa8c16' : '#ccc' }}
              />
              <span className="approval-text">
                {approvalView ? Lang.t('matter.approvalMode') : Lang.t('matter.normalMode')}
              </span>
            </div>
          ) : canShowExportAudit && (
            <Button 
              danger
              size="small"
              icon={<ExportOutlined />}
              onClick={this.handleOpenExportAuditModal}
              className="export-audit-btn-mobile"
            >
              {Lang.t('matter.exportAudit')}
            </Button>
          )}
  
          <div className="search-wrapper">
            <Checkbox 
              checked={checkContent}
              onChange={this.handleFullTextSearchChange}
              className="full-text-checkbox-mobile"
            >
              {Lang.t('matter.fullTextSearch')}
            </Checkbox>
            <Input.Search
              placeholder={Lang.t('matter.searchFile')}
              onSearch={(value) => this.searchFile(value, checkContent)}
              onChange={(e) => this.changeSearch(e)}
              enterButton
              size="small"
              loading={searchLoading}
              disabled={searchLoading}
              className="mobile-search-input"
            />
          </div>
        </div>
      </div>
    );
  };
  renderGridView() {
    const { pager } = this;
    const { thumbnailUrls, thumbnailLoading, editingMatterUuid, editingMatterName, isMobile } = this.state;
    const canDownload = this.checkDownloadPermission();
    const hasFullPermission = this.checkHandlePermission();
    const canMove = this.checkMovePermission();
  
    return (
      <Row gutter={[16, 16]} className="grid-view-container">
        {pager.data.map((matter) => {
          const uuid = matter.uuid!;
          const isImage = !matter.dir && ThumbnailHelper.isThumbnailSupported(matter.name);
          const thumbnailUrl = thumbnailUrls[uuid];
          const isLoading = thumbnailLoading[uuid];
          const isEditing = editingMatterUuid === uuid;
          const approvalStatus = this.getApprovalStatus(matter);
          const statusText = this.getApprovalStatusText(approvalStatus);
          const statusColor = this.getApprovalStatusColor(approvalStatus);
          const isPending = approvalStatus === 'pending' || approvalStatus === 'outsend_pending';
  
          const menu = (
            <Menu onClick={(e) => this.handleMenuClick(matter, e.key, e)}>
              {!matter.dir && canDownload && (
                <Menu.Item key="download" icon={<DownloadOutlined />}>
                  {Lang.t('matter.download')}
                </Menu.Item>
              )}
              <Menu.Item key="preview" icon={<EyeOutlined />}>
                {Lang.t('matter.preview')}
              </Menu.Item>
              {isMobile && this.user.role === UserRole.ADMINISTRATOR && isPending && (
                <Menu.Item key="approve" icon={<CheckCircleOutlined />}>
                  {Lang.t('matter.approve')}
                </Menu.Item>
              )}
              {isMobile && this.user.role === UserRole.ADMINISTRATOR && isPending && (
                <Menu.Item key="reject" icon={<CloseCircleOutlined />}>
                  {Lang.t('matter.reject')}
                </Menu.Item>
              )}
              {hasFullPermission && (
                <>
                  <Menu.Item key="rename" icon={<EditOutlined />}>
                    {Lang.t('matter.rename')}
                  </Menu.Item>
                  <Menu.Item key="delete" icon={<DeleteOutlined />} danger>
                    {Lang.t('delete')}
                  </Menu.Item>
                </>
              )}
              {canMove && !matter.dir && (
                <Menu.Item key="move" icon={<DragOutlined />}>
                  {Lang.t('matter.move')}
                </Menu.Item>
              )}
            </Menu>
          );
  
          // 处理卡片点击（文件夹进入目录，文件预览）
          const handleCardClick = () => {
            if (isEditing) return;
            if (matter.dir) {
              this.goToDirectory(matter.uuid!);
            } else {
              this.handlePreview(matter);
            }
          };
  
          return (
            <Col key={uuid} xs={12} sm={8} md={6} lg={4} xl={3}>
              {/* 外层容器：使用捕获阶段事件确保文件夹点击立即响应，但不干扰内部按钮 */}
              <div
                className="grid-card-clickable"
                onClickCapture={(e) => {
                  const target = e.target as HTMLElement;
                  if (target.closest('.cell-hot') || target.closest('.ant-checkbox')) return;
                  e.stopPropagation();
                  handleCardClick();
                }}
                onTouchStartCapture={(e) => {
                  if (isMobile && !isEditing) {
                    const target = e.target as HTMLElement;
                    if (target.closest('.cell-hot') || target.closest('.ant-checkbox')) return;
                    e.preventDefault();
                    e.stopPropagation();
                    handleCardClick();
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <Card
                  className={`matter-grid-card ${isMobile ? 'mobile-view' : ''}`}
                  hoverable
                  size="small"
                  actions={
                    isEditing
                      ? [
                          <Tooltip title={Lang.t('save')}>
                            <SaveOutlined
                              onClick={(e) => {
                                e.stopPropagation();
                                this.saveRename(matter);
                              }}
                              style={{ color: '#52c41a' }}
                            />
                          </Tooltip>,
                          <Tooltip title={Lang.t('cancel')}>
                            <CloseOutlined
                              onClick={(e) => {
                                e.stopPropagation();
                                this.cancelRename();
                              }}
                              style={{ color: '#ff4d4f' }}
                            />
                          </Tooltip>,
                        ]
                      : [
                          <Checkbox
                            checked={matter.check}
                            onClick={(e) => {
                              e.stopPropagation();
                              matter.check = !matter.check;
                              this.checkMatter(matter);
                            }}
                          />,
                          <Tooltip title={Lang.t('share.detail')}>
                            <FileTextOutlined
                              onClick={(e) => {
                                e.stopPropagation();
                                this.goDetail(matter);
                              }}
                            />
                          </Tooltip>,
                          <Tooltip title={Lang.t('matter.preview')}>
                            <EyeOutlined
                              onClick={(e) => {
                                e.stopPropagation();
                                if (matter.dir) {
                                  this.goToDirectory(matter.uuid!);
                                } else {
                                  this.handlePreview(matter);
                                }
                              }}
                            />
                          </Tooltip>,
                          <Tooltip title={Lang.t('more')}>
                            <Dropdown overlay={menu} trigger={['click']} disabled={isEditing}>
                              <MoreOutlined onClick={(e) => e.stopPropagation()} />
                            </Dropdown>
                          </Tooltip>,
                        ]
                  }
                  cover={
                    <div className="matter-thumbnail-container">
                      {isImage ? (
                        <div
                          className="matter-thumbnail"
                          style={{
                            width: '100%',
                            height: '150px',
                            backgroundImage: thumbnailUrl ? `url("${thumbnailUrl}")` : undefined,
                            backgroundColor: '#f5f5f5',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px 4px 0 0',
                            overflow: 'hidden',
                            position: 'relative',
                          }}
                        >
                          {isLoading ? (
                            <div className="thumbnail-loading">
                              <SyncOutlined spin style={{ fontSize: '24px', color: '#1890ff' }} />
                            </div>
                          ) : !thumbnailUrl ? (
                            this.getFileIcon(matter)
                          ) : null}
                          {thumbnailUrl && (
                            <div className="image-badge">
                              <FileImageOutlined style={{ fontSize: '12px', color: '#fff' }} />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div
                          className="matter-icon"
                          style={{
                            width: '100%',
                            height: '150px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#fafafa',
                            borderRadius: '4px 4px 0 0',
                          }}
                        >
                          {this.getFileIcon(matter)}
                        </div>
                      )}
                    </div>
                  }
                >
                  <div className="matter-grid-content">
                    {isEditing ? (
                      <div className="matter-edit-container">
                        <Input
                          value={editingMatterName}
                          onChange={(e) => this.setState({ editingMatterName: e.target.value })}
                          onPressEnter={() => this.saveRename(matter)}
                          autoFocus
                          size="small"
                          style={{ width: '100%' }}
                        />
                      </div>
                    ) : (
                      <div className="matter-info">
                        <div className="matter-name" title={matter.name}>
                          {matter.name}
                        </div>
                        <div className="matter-meta">
                          {!matter.dir && (
                            <div className="matter-size">
                              {ThumbnailHelper.formatFileSize(matter.size || 0)}
                            </div>
                          )}
                          <div className="matter-time">{DateUtil.simpleDate(matter.createTime)}</div>
                        </div>
                        {isMobile && statusText !== Lang.t('matter.normal') && (
                          <div
                            className={`mobile-approval-status ${isPending ? 'pending-status' : ''}`}
                            style={{
                              display: 'inline-block',
                              marginTop: '8px',
                              padding: '6px 10px',
                              borderRadius: '16px',
                              fontSize: '12px',
                              fontWeight: '500',
                              backgroundColor: `${statusColor}15`,
                              border: `1px solid ${statusColor}30`,
                              color: statusColor,
                              whiteSpace: 'nowrap',
                              maxWidth: '100%',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              cursor: isPending ? 'pointer' : 'default',
                              transition: 'all 0.2s',
                              userSelect: 'none',
                              WebkitTapHighlightColor: 'transparent',
                              minHeight: '32px',
                              minWidth: '70px',
                              lineHeight: '1',
                              textAlign: 'center',
                              boxSizing: 'border-box',
                              touchAction: 'manipulation',
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isPending) {
                                this.handleMobileStatusClick(matter, e);
                              }
                            }}
                            data-clickable={isPending}
                          >
                            {statusText}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Card>
              </div>
            </Col>
          );
        })}
      </Row>
    );
  }
  renderListView() {
    const { isMobile } = this.state;
    return (
      <div className={`list-view-container ${isMobile ? 'mobile-mode' : ''}`}>
        {this.uploadMattersMap[this.getSpaceUuid()]?.map((m) => (
          <UploadMatterPanel key={m.uuid} matter={m} />
        ))}
        {this.director.createMode ? (
          <MatterPanel
            mode="normal"
            ref={this.newMatterRef}
            matter={this.newMatter}
            director={this.director}
            onCreateDirectoryCallback={() => this.refreshAndClearSelection()}
            isMobile={isMobile}
          />
        ) : null}
        <div>
          {this.pager.loading || this.pager.data.length ? (
            this.pager.data.map((matter) => (
              <MatterPanel
                mode={this.isInSpace ? 'space' : 'normal'}
                spaceMemberRole={
                  this.isInSpace ? this.spaceMember.role! : undefined
                }
                key={matter.uuid!}
                director={this.director}
                matter={matter}
                onGoToDirectory={(id: string) => this.goToDirectory(id)}
                onDeleteSuccess={() => this.pagerAndCapacityRefresh()}
                onCheckMatter={(m?: Matter) => this.checkMatter(m)}
                onPreviewImage={(m: Matter) => this.handlePreview(m)}
                onGoDetail={(m: Matter) => {
                  if (m.dir) {
                    this.goDetail(m);
                  } else {
                    this.goDetail(m);
                  }
                }}
                isMobile={isMobile}
                onApproveMatter={(m: Matter) => this.handleApprove(m)}
                onRejectMatter={(m: Matter) => this.handleReject(m)}
              />
            ))
          ) : (
            <Empty description={Lang.t('matter.noContentYet')} />
          )}
        </div>
      </div>
    );
  }

  render() {
    const { pager, selectedMatters, dragEnterCount } = this;
    const { 
      approvalView, 
      crawlModalVisible, 
      showExportAuditModal, 
      selectedMatterForAudit, 
      checkContent, 
      searchLoading, 
      forwardModalVisible,
      viewMode,
      isMobile 
    } = this.state;
    
    const canShowShareButton = !this.isInSpace && !this.user.disableShare;
    const isPreviewOnly = this.checkPreviewOnlyPermission();
    const isUploadPreview = this.checkUploadPreviewPermission();
    const hasFullPermission = this.checkHandlePermission();
    const canDownload = this.checkDownloadPermission();
    const canMove = this.checkMovePermission();
    const canCreate = this.checkCreatePermission();
    
    return (
      <div className={`matter-list ${isMobile ? 'mobile-device' : ''}`} ref={this.wrapperRef}>
        {dragEnterCount > 0 ? (
          <div className="obscure">
            <CloudUploadOutlined className="white f50" />
          </div>
        ) : null}
        <BreadcrumbPanel breadcrumbModels={this.getBreadcrumbModels()} />
    
        {/* 根据设备类型渲染不同的头部区域 */}
        {isMobile ? (
          this.renderMobileHeader()
        ) : (
          // PC端保持原有布局
          <Row gutter={[24, 16]} className="mt10">
            <Col xs={24} sm={24} md={12} lg={14}>
              <div className="button-group">
                <AntdSpace className="buttons" wrap>
                  <Button.Group className="view-toggle-buttons">
                    <Tooltip title={Lang.t('matter.listView')}>
                      <Button
                        type={viewMode === 'list' ? 'primary' : 'default'}
                        icon={<BarsOutlined />}
                        onClick={() => this.toggleViewMode('list')}
                        size="small"
                      />
                    </Tooltip>
                    <Tooltip title={Lang.t('matter.gridView')}>
                      <Button
                        type={viewMode === 'grid' ? 'primary' : 'default'}
                        icon={<AppstoreOutlined />}
                        onClick={() => this.toggleViewMode('grid')}
                        size="small"
                      />
                    </Tooltip>
                  </Button.Group>

                  {isPreviewOnly ? (
                    <Button
                      className="mb10 dark-green-btn"
                      onClick={() => this.refresh()}
                    >
                      <SyncOutlined />
                      {Lang.t('refresh')}
                    </Button>
                  ) : (
                    <>
                      {(isUploadPreview || hasFullPermission) && (
                        <>
                          {selectedMatters.length !== pager.data.length ? (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.checkAll()}
                            >
                              <PlusSquareOutlined />
                              {Lang.t('selectAll')}
                            </Button>
                          ) : null}
                          {pager.data.length &&
                          selectedMatters.length === pager.data.length ? (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.checkNone()}
                            >
                              <MinusSquareOutlined />
                              {Lang.t('cancel')}
                            </Button>
                          ) : null}
                        </>
                      )}
                      
                      {selectedMatters.length ? (
                        <>
                          {canDownload && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.downloadZip()}
                            >
                              <DownloadOutlined />
                              {Lang.t('download')}
                            </Button>
                          )}
                          {hasFullPermission && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.deleteBatch()}
                            >
                              <DeleteOutlined />
                              {Lang.t('delete')}
                            </Button>
                          )}
                          {canMove && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.toggleMoveBatch()}
                            >
                              <DragOutlined />
                              {Lang.t('matter.move')}
                            </Button>
                          )}
                          {this.isInSpace && (hasFullPermission || canDownload || canMove) && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.forwardBatch()}
                            >
                              <SendOutlined />
                              {Lang.t('matter.forward')}
                            </Button>
                          )}
                          {!this.isInSpace && hasFullPermission && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.openForwardDialog()}
                            >
                              <SendOutlined />
                              {Lang.t('matter.forwardToSpace')}
                            </Button>
                          )}
                          {canShowShareButton && hasFullPermission && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.shareBatch()}
                            >
                              <ShareAltOutlined />
                              {Lang.t('matter.share')}
                            </Button>
                          )}
                        </>
                      ) : null}
                      
                      {(isUploadPreview || hasFullPermission) && (
                        <>
                          <Upload
                            className="ant-upload"
                            customRequest={(e) => this.triggerUpload(e)}
                            showUploadList={false}
                            multiple
                          >
                            <Button className="mb10 dark-green-btn">
                              <CloudUploadOutlined />
                              {Lang.t('matter.upload')}
                            </Button>
                          </Upload>
                          {canCreate && (
                            <Button
                              className="mb10 dark-green-btn"
                              onClick={() => this.createDirectory()}
                            >
                              <FolderOutlined />
                              {Lang.t('matter.create')}
                            </Button>
                          )}
                        </>
                      )}
                      
                      <Button
                        className="mb10 dark-green-btn"
                        onClick={() => this.refresh()}
                      >
                        <SyncOutlined />
                        {Lang.t('refresh')}
                      </Button>
                      
                      {(isUploadPreview || hasFullPermission) && (
                        <Tooltip title={Lang.t('matter.uploadDirTooltip')}>
                          <Button
                            className="mb10 dark-green-btn"
                            onClick={() => this.triggerButtonDirUpload()}
                          >
                            <FolderOpenOutlined />
                            {Lang.t('matter.uploadDir')}
                          </Button>
                        </Tooltip>
                      )}
                    </>
                  )}
                </AntdSpace>
              </div>
            </Col>
      
            <Col xs={24} sm={24} md={12} lg={10}>
              <div className="right-controls">
                <div className="flex-end-container">
                  {this.user.role === UserRole.ADMINISTRATOR ? (
                    <div className="approval-switch">
                      <div className="approval-switch-row">
                        <Switch
                          checked={approvalView}
                          onChange={this.handleApprovalViewChange}
                          checkedChildren={Lang.t('matter.approvalMode')}
                          unCheckedChildren={Lang.t('matter.normalMode')}
                          style={{
                            backgroundColor: approvalView ? '#fa8c16' : '#ccc',
                          }}
                        />
                        <span className="approval-text">
                          {approvalView ? Lang.t('matter.tonormalMode') : Lang.t('matter.toapprovalMode')}
                        </span>
                      </div>
                      <div className="approval-hint">
                        <ExclamationCircleOutlined style={{ marginRight: '4px' }} />
                        {Lang.t('approvalHint')}
                      </div>
                    </div>
                  ) : (
                    <div className="export-audit-btn">
                      <Button 
                        danger
                        icon={<ExportOutlined />}
                        onClick={this.handleOpenExportAuditModal}
                        size="small"
                      >
                        {Lang.t('matter.exportAudit')}
                      </Button>
                    </div>
                  )}
                  <div className="search-area">
                    <Checkbox 
                      checked={checkContent}
                      onChange={this.handleFullTextSearchChange}
                      className="full-text-checkbox"
                    >
                      {Lang.t('matter.fullTextSearch')}
                    </Checkbox>
                    <Input.Search
                      className="search-input"
                      placeholder={Lang.t('matter.searchFile')}
                      onSearch={(value) => this.searchFile(value, checkContent)}
                      onChange={(e) => this.changeSearch(e)}
                      enterButton
                      size="small"
                      loading={searchLoading}
                      disabled={searchLoading}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {pager.data.length ? (
          <MatterSortPanel pager={pager} refresh={() => this.refresh()} />
        ) : null}
        
        {isMobile && approvalView && (
          <div className="mobile-approval-tip" style={{
            backgroundColor: '#fff7e6',
            border: '1px solid #ffd591',
            borderRadius: '4px',
            padding: '8px 12px',
            marginBottom: '12px',
            fontSize: '12px',
            color: '#fa8c16',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}>
            <ExclamationCircleOutlined />
            <span>{Lang.t('matter.mobileApprovalTip')}</span>
          </div>
        )}
        
        {this.dirUploadPhase === 'done' && this.uploadErrorLogs.length === 0 && (
          <div style={{ padding: '8px 16px', background: '#f6ffed', borderRadius: 6, marginBottom: 12, border: '1px solid #b7eb8f', color: '#52c41a' }}>
            {Lang.t('matter.uploaded', '上传完成')}
          </div>
        )}
        {this.dirUploadPhase === 'done' && this.uploadErrorLogs.length > 0 && (
          <div style={{ padding: '8px 16px', background: '#fff7e6', borderRadius: 6, marginBottom: 12, border: '1px solid #ffd591', color: '#fa8c16' }}>
            {Lang.t('matter.uploadedWithErrors', this.uploadErrorLogs.length)}
          </div>
        )}
        
        {viewMode === 'list' ? this.renderListView() : this.renderGridView()}
        
        {pager.totalItems > pager.pageSize && (
          <Pagination
            className="matter-pagination pull-right mt10"
            onChange={(page) => this.changePage(page)}
            current={pager.page + 1}
            total={pager.totalItems}
            pageSize={pager.pageSize}
            hideOnSinglePage
          />
        )}
        
        {crawlModalVisible && (
          <MatterCrawlModal
            spaceUuid={this.getSpaceUuid()}
            puuid={this.currentDirectory.uuid!}
            onClose={this.handleCloseMatterCrawlModal.bind(this)}
          />
        )}
  
        {showExportAuditModal && (
          <ExportAuditModal
            visible={showExportAuditModal}
            matter={selectedMatterForAudit}
            user={this.user}
            onClose={() => this.setState({ 
              showExportAuditModal: false, 
              selectedMatterForAudit: null 
            })}
            onSubmit={this.handleExportAudit}
          />
        )}
  
        {forwardModalVisible && (
          <ForwardDialogModal
            visible={forwardModalVisible}
            onClose={() => this.setState({ forwardModalVisible: false })}
            onForward={this.handleForward}
            matterUuids={this.selectedMatters.map(m => m.uuid!).filter(uuid => uuid)}
            spaceUuid={this.getSpaceUuid()}
          />
        )}

        {this.renderForwardProgressModal()}
      </div>
    );
  }
}